<template>
  <div >
    <file-uploader :compMode="compMode" entite="Entrepreneur"></file-uploader>

    <div class="card mb-3">
        <div class="card-header">
            <i class="fa fa-briefcase"></i> 
            <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('entrepreneur.create.title') }}</span>
            <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('entrepreneur.edit.title') }}</span>
            <span v-if="compMode == CRUDMODE.READ">{{ $t('entrepreneur.view.title') }}</span>
                <toggle-button
        style="margin-left:20px"
          v-model="entrepreneur.displayInWebsite"
          :sync="true"
          :width="200"
          :height="30"
          :font-size="14"
          :labels="{checked: 'Affiché sur le site web', unchecked: 'Masqué sur le site web'}"
        />
        </div>
        <div class="card-body">

            <errorMessage v-bind:message="error"></errorMessage>

            <form>
                <photo-uploader :compMode="compMode" entite="Entrepreneur" :fileType="fileType_personProfilePicture" ref="photoUploader"></photo-uploader>

                <div class="row">
                    <div class="form-group col-md-2">
                        <label for="numberInput">{{ $t('entrepreneur.form.number') }}*</label>
                        <input disabled readonly v-model="entrepreneur.id "type="text" class="form-control" ></input>
                    </div>

                    <div class="form-group col-md-2">
                        
                    </div>

                    <div class="form-group col-md-4">
                        <label for="nameInput">{{ $t('entrepreneur.form.name') }}*</label>
                        <input v-model.trim="entrepreneur.name" v-validate="'required'" name="name" type="text" class="form-control" 
                           id="nameInput" v-bind:placeholder="$t('entrepreneur.form.name')" />
                        <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
                    </div>

                    <div class="form-group col-md-4">
                        <label for="familyNameInput">{{ $t('entrepreneur.form.familyName') }}*</label>
                        <input v-model.trim="entrepreneur.familyName" v-validate="'required'" name="familyName" type="text" 
                          class="form-control" id="familyNameInput" v-bind:placeholder="$t('entrepreneur.form.familyName')" />
                        <span class="text-danger" v-if="errors.has('familyName')">{{ errors.first('familyName') }}</span>
                    </div>
                </div>

                <div class="row">

                    <div class="form-group col-md-2">
                        <label for="sexInput">{{ $t('entrepreneur.form.sex') }}*</label>
                        <input type="hidden" name="EntrepreneurSex_validate" v-model="EntrepreneurSex_validate" v-validate="'required'" />
                        <select v-model="entrepreneur.sex" v-validate="'required'" class="form-control" id="sexInput"  >
                            <option v-for="s in sexes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                        </select>
                        <span class="text-danger" v-if="errors.has('EntrepreneurSex_validate')">{{ $t('validations.required')}}.</span>
                    </div>

                    <div class="form-group col-md-2">
                        <label for="immigrantInput">{{ $t('entrepreneur.form.immigrant') }}</label>
                        <div class="col-9">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" name="immigrant"  value="1" class="custom-control-input" id="immigrantInput" v-model="entrepreneur.immigrant">
                                <span class="custom-control-indicator"></span>
                                <span class="custom-control-label">Oui</span>
                            </label>
                        </div>
                        <span class="text-danger" v-if="errors.has('immigrant')">{{ errors.first('immigrant') }}</span>
                    </div>

                    <div class="form-group col-md-4">
                        <label for="languageInput">{{ $t('entrepreneur.form.immigrantCountry') }}</label>
                        
                        <multiselect v-model="entrepreneur.immigrantCountry"
                            :options="immigrantCountrys" :multiple="false" :taggable="false"
                            v-bind:placeholder="$t('entrepreneur.form.immigrantCountry')" 
                            v-bind:deselect-label="$t('entrepreneur.form.removeLanguage')"
                            v-bind:select-label="$t('entrepreneur.form.selectLanguage')">
                        </multiselect>
  
                        <span class="text-danger" v-if="errors.has('immigrantCountry')">{{ errors.first('immigrantCountry') }}</span>
                    </div>

                    <div class="form-group col-md-4">
                        <label for="languageInput">{{ $t('entrepreneur.form.language') }}*</label>
                        
                        <multiselect v-model="entrepreneur.nativeLanguage"
                            :options="languageOptions" :multiple="false" :taggable="true" @tag="addLanguageTag"
                            v-bind:tag-placeholder="$t('entrepreneur.form.selectLanguage')" 
                            v-bind:placeholder="$t('entrepreneur.form.language')" 
                            v-bind:deselect-label="$t('entrepreneur.form.removeLanguage')"
                            v-bind:select-label="$t('entrepreneur.form.selectLanguage')"
                            >
                        </multiselect>
  
                        <span class="text-danger" v-if="errors.has('nativeLanguage')">{{ errors.first('nativeLanguage') }}</span>
                    </div>
                    
                </div>

                <div class="row">
                    <div class="form-group col-md-4">
                        <label for="educationInput">{{ $t('entrepreneur.form.education') }}</label>
                        <select v-model="entrepreneur.education" class="form-control" id="educationInput"  >
                            <option v-for="s in educationLevels" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="numberEnterpriseAsManagerInput">{{ $t('entrepreneur.form.numberEnterpriseAsManager') }}</label>
                        <input v-model.trim="entrepreneur.numberEnterpriseAsManager" name="numberEnterpriseAsManager" type="number" 
                             class="form-control" id="numberEnterpriseAsManagerInput" v-bind:placeholder="$t('entrepreneur.form.numberEnterpriseAsManager')">
                        <span class="text-danger" v-if="errors.has('numberEnterpriseAsManager')">{{ errors.first('numberEnterpriseAsManager') }}</span>
                    </div>

                    <div class="form-group col-md-4">
                        <label for="emailInput">{{ $t('entrepreneur.form.email') }}</label>
                        <input v-model.trim="entrepreneur.email"  v-validate="'email'" name="email" type="text" class="form-control" 
                         id="emailInput" v-bind:placeholder="$t('entrepreneur.form.email')">
                        <span class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</span>
                    </div>   

                </div>

                <div class="row">
                    <div class="form-group col-md-4">
                        <label for="birthdateInput">{{ $t('member.form.birthdate') }}</label>
                        <moment-date-picker v-model="entrepreneur.birthdate" :required="false"></moment-date-picker>
                    </div>
                    
                    <div class="form-group col-md-2">
                        <label for="phoneInput">{{ $t('entrepreneur.form.phone') }}</label>
                        <input v-model.trim="entrepreneur.phone" v-mask="'(###) ###-####'"  
                         v-validate="{ rules: { regex: phoneRegex() } }" name="phone" type="text" class="form-control" id="phoneInput" placeholder="(999) 999-9999">
                        <span class="text-danger" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="cellphoneInput">{{ $t('entrepreneur.form.cellphone') }}</label>
                        <input v-model.trim="entrepreneur.cellphone" v-mask="'(###) ###-####'"  
                        v-validate="{ rules: { regex: phoneRegex() } }" name="cellphone" type="text" class="form-control" id="cellphoneInput" placeholder="(999) 999-9999">
                        <span class="text-danger" v-if="errors.has('cellphone')">{{ errors.first('cellphone') }}</span>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="officePhoneInput">{{ $t('entrepreneur.form.officePhone') }}</label>
                        <input v-model.trim="entrepreneur.officePhone" v-mask="'(###) ###-####'"  
                        v-validate="{ rules: { regex: phoneRegex() } }" name="officePhone" type="text" class="form-control" id="officePhoneInput" placeholder="(999) 999-9999">
                        <span class="text-danger" v-if="errors.has('officePhone')">{{ errors.first('officePhone') }}</span>
                    </div>

                    <div class="form-group col-md-2">
                        <label for="officePhoneExtensionInput">{{ $t('entrepreneur.form.officePhoneExtension') }}</label>
                        <input v-model.trim="entrepreneur.officePhoneExtension" name="officePhoneExtension" maxlength="10"  
                        type="text" class="form-control" id="officePhoneExtensionInput" v-bind:placeholder="$t('entrepreneur.form.officePhoneExtension')">
                        <span class="text-danger" v-if="errors.has('officePhoneExtension')">{{ errors.first('officePhoneExtension') }}</span>
                    </div>

                </div>

                <div class="row">
                    <div class="form-group col-md-12">
                        <div class="card">
                            <div class="card-header">{{ $t('entrepreneur.form.social.title') }}</div>
                            <div class="card-body">

                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <label for="socialNetworkInput">{{ $t('entrepreneur.form.social.socialNetwork') }}</label>

                                        <multiselect v-model="entrepreneur.social.socialNetworks" :options="socialNetworks" :multiple="true" 
                                            :close-on-select="false" :clear-on-select="false" :hide-selected="true" :preserve-search="true" 
                                            v-bind:placeholder="$t('entrepreneur.form.social.socialNetwork')" :preselect-first="true">
                                        </multiselect>
                                        <span class="text-danger" v-if="errors.has('socialNetwork')">{{ errors.first('socialNetwork') }}</span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-md-3">
                                        <label for="infolettreInput">{{ $t('entrepreneur.form.social.infolettre') }}</label>
                                        <div class="col-9">
                                            <label class="custom-control custom-checkbox">
                                                <input type="checkbox" name="infolettre" value="1" class="custom-control-input"  
                                                    id="infolettreInput" v-model="entrepreneur.infolettre">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-label">Oui</span>
                                            </label>
                                        </div>
                                        <span class="text-danger" v-if="errors.has('infolettre')">{{ errors.first('infolettre') }}</span>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label for="followFacebookInput">{{ $t('social.followFacebook') }}</label>
                                        <div class="col-9">
                                            <label class="custom-control custom-checkbox">
                                                <input type="checkbox" name="followFacebook" value="1" class="custom-control-input"  
                                                    id="followFacebookInput" v-model="entrepreneur.social.followFacebook">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-label">Oui</span>
                                            </label>
                                        </div>
                                        <span class="text-danger" v-if="errors.has('followFacebook')">{{ errors.first('followFacebook') }}</span>
                                    </div>
                                
                                    <div class="form-group col-md-3">
                                        <label for="followLinkedinGroupInput">{{ $t('social.followLinkedinGroup') }}</label>
                                        <div class="col-9">
                                            <label class="custom-control custom-checkbox">
                                                <input type="checkbox" name="followLinkedinGroup" value="1" class="custom-control-input"  
                                                    id="followLinkedinGroupInput" v-model="entrepreneur.social.followLinkedinGroup">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-label">Oui</span>
                                            </label>
                                        </div>
                                        <span class="text-danger" v-if="errors.has('followLinkedinGroup')">{{ errors.first('followLinkedinGroup') }}</span>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label for="followLinkedinProfileInput">{{ $t('social.followLinkedinProfile') }}</label>
                                        <div class="col-9">
                                            <label class="custom-control custom-checkbox">
                                                <input type="checkbox" name="followLinkedinProfile" value="1" class="custom-control-input" 
                                                    id="followLinkedinProfileInput" v-model="entrepreneur.social.followLinkedinProfile">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-label">Oui</span>
                                            </label>
                                        </div>
                                        <span class="text-danger" v-if="errors.has('followLinkedinProfile')">{{ errors.first('followLinkedinProfile') }}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <address-component  v-bind:address="entrepreneur.address" :required="false"></address-component>

                <company-entrepreneur v-bind:companyEntrepreneurs="entrepreneur.companyEntrepreneur" :isCompanyPage="false" v-bind:compMode="compMode"></company-entrepreneur>

                <view-event-person v-if="compMode == CRUDMODE.READ" :entrepreneurId="entrepreneur.id"></view-event-person>

                <a @click="createEntrepreneur" v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" id="addButton" class="btn btn-primary">
                    {{ $t('form.create_button') }}
                </a>

                <a @click="editEntrepreneur" v-if="compMode == CRUDMODE.UPDATE" id="editButton" class="btn btn-primary">
                    {{ $t('form.edit_button') }}
                </a>
                
            </form>
        </div>
    </div>
</div>
</template>

<script>
import {
  EntrepreneurServiceClient,
  PersonServiceClient,
  EntrepreneurDto,
  AddressDto,
  SocialDto,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import AddressComponent from '../Address.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import Enum from '@/shared/enum'
import MomentDatePicker from '../../shared/components/MomentDatePicker'
import CompanyEntrepreneur from '../projects/CompanyEntrepreneur.vue'
import ViewEventPerson from '../events/ViewEventPerson'
import {ToggleButton} from 'vue-js-toggle-button'
import PhotoUploader from '../../shared/components/PhotoUploader.vue'
export default {
  name: 'CreateEntrepreneur',
  mixins: [CrudMixin],

  data() {
    let dto = new EntrepreneurDto()
    dto.displayInWebsite = true
    dto.init({nativeLanguage: 'Français'})
    dto.displayInWebsite = true
    dto.address = new AddressDto()
    dto.address.init({})
    dto.companyEntrepreneur = []
    dto.social = new SocialDto()
    dto.social.init({})

    return {
      ready: false,
      error: '',
      educationLevels: [],
      sexes: [],
      immigrantCountrys: [],
      entrepreneur: dto,
      languageOptions: ['Français', 'Anglais', 'Espagnol'],
      socialNetworks: ['LinkedIn', 'Facebook', 'Twitter', 'Instagram', 'Slack'],
    }
  },
  computed: {
    EntrepreneurSex_validate: function() {
      return this.entrepreneur.sex
    },
    fileType_personProfilePicture: function() {
      return Enum.FileType.PERSONPROFILEPICTURE
    },
  },

  methods: {
    cleanEntity: function() {
      let cleanEntrepreneur = this.cleanFields(this.entrepreneur)

      if (cleanEntrepreneur.companyEntrepreneur != null) {
        for (var ix = 0; ix < cleanEntrepreneur.companyEntrepreneur.length; ix++) {
          if (cleanEntrepreneur.companyEntrepreneur[ix].company != null) {
            cleanEntrepreneur.companyEntrepreneur[ix].companyId = cleanEntrepreneur.companyEntrepreneur[ix].company.id
          }
          cleanEntrepreneur.companyEntrepreneur[ix].company = null
          cleanEntrepreneur.companyEntrepreneur[ix].entrepreneur = null
        }
      } else {
        cleanEntrepreneur.companyEntrepreneur = []
      }
      return cleanEntrepreneur
    },
    createEntrepreneur: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let entrepreneurService = ServiceFactory.create(EntrepreneurServiceClient)

            entrepreneurService
              .create(this.cleanEntity())
              .then(function(res) {
                self.persistFiles(res.id)
                self.$refs.photoUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('entrepreneur.create.succes'), 'success')
                this.$router.push({path: '/entrepreneurs'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editEntrepreneur: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let entrepreneurService = ServiceFactory.create(EntrepreneurServiceClient)

            entrepreneurService
              .update(this.cleanEntity())
              .then(function(res) {
                self.persistFiles(self.$route.params.id)
                self.$refs.photoUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('entrepreneur.edit.succes'), 'success')
                this.$router.push({path: '/Entrepreneurs'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchData: function() {
      let entrepreneurService = ServiceFactory.create(EntrepreneurServiceClient)
      let personService = ServiceFactory.create(PersonServiceClient)

      let self = this
      let promisseAll

      let getSexes = personService.getSexes()
      let getEducations = personService.getEducations()
      let getImmigrantCountrys = entrepreneurService.getCountrys()

      getImmigrantCountrys
        .then(res => {
          self.immigrantCountrys = res
        })
        .catch(err => {
          console.log(err)
        })

      getSexes
        .then(res => {
          self.sexes = res
        })
        .catch(err => {
          console.log(err)
        })

      getEducations
        .then(res => {
          self.educationLevels = res
        })
        .catch(err => {
          console.log(err)
        })

      if (this.compMode != Enum.Mode.CREATE) {
        let getEntrepreneur = entrepreneurService.get(this.$route.params.id)
        getEntrepreneur
          .then(res => {
            self.entrepreneur = res

            if (self.entrepreneur.companyEntrepreneur == null) {
              self.entrepreneur.companyEntrepreneur = []
            }

            if (self.entrepreneur.social == null) self.entrepreneur.social = new SocialDto({})

            self.checkCopyMode(self.entrepreneur)
          })
          .catch(err => {
            console.log(err)
          })

        promisseAll = Promise.all([getSexes, getEducations, getImmigrantCountrys, getEntrepreneur])
      } else {
        promisseAll = Promise.all([getSexes, getEducations, getImmigrantCountrys])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
    addLanguageTag: function(tag) {
      this.languageOptions.push(tag)
      this.entrepreneur.nativeLanguage = tag
    },
  },
  components: {
    errorMessage: ErrorMessage,
    AddressComponent: AddressComponent,
    multiselect: Multiselect,
    CompanyEntrepreneur,
    'moment-date-picker': MomentDatePicker,
    ViewEventPerson,
    ToggleButton,
    'photo-uploader': PhotoUploader,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .btn-primary {
    color: #fff !important;
    cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/entrepreneur/CreateEntrepreneur.vue